import React, { Component } from 'react';
import * as Scroll from 'react-scroll';
import SelectInput from './selectInput';
import ErrorBlock from './errorBlock';
import Axios from 'axios';
import { translate } from 'react-i18next';
import ReactGA from 'react-ga';
import store from '../store';

const FILTERS = {
  manufacturer: {},
  series: {},
  fuel: {},
  // year: {},
  // displacement: {},
};

class RefineCVLSearchForm extends Component {
  state = {};

  ref = React.createRef();

  componentWillMount() {
    const { data } = this.props;

    this.setState({
      data: data ? data.results : null,
      searchTerms: data ? data.searchTerms : null,
      groups: data ? data.groups : null,
      type: data ? data.type : null,
      error: false,
      currentManufacturer: '',
    });
  }

  componentDidMount() {
    const { data } = this.props;
    const resultData = this.getResults(data.results, data.searchTerms);
    this.setState({ resultData });

    if (resultData.manufacturer) {
      this.setState({
        currentManufacturer: resultData.manufacturer,
      });
    }

    this.updateScrollPosition();
  }

  updateScrollPosition = () => {
    if (this.ref) {
      const scrollPos = this.ref.offsetTop + this.ref.offsetHeight - 100;
      return Scroll.animateScroll.scrollTo(scrollPos, { duration: 250 });
    } else {
      return false;
    }
  };

  onClose = () => {
    this.forceUpdate();
  };

  equipmentSelected = (selectedOption) => {
    this.equipment = selectedOption;
    this.forceUpdate();
    this.updateScrollPosition();
  };

  goToResults = () => {
    const { equipment } = this.props;
    equipment(this.equipment);
  };

  getResults = (data, searchTerms) => {
    const filters = JSON.parse(JSON.stringify(FILTERS));
    const facets = data.facets;
    const arr = [];

    if (searchTerms.replace(/\s/g, '')) {
      for (let key in filters) {
        const currentFacet = facets.find((facet) => facet.name.toLowerCase() === key);
        if (currentFacet) {
          delete filters[key];
        } else {
          filters[key] = data.model[0][key];

          let obj = {};
          obj[key] = filters[key];
          arr.push(obj);
        }
      }
    }

    return arr.reduce(function (result, currentObject) {
      for (let key in currentObject) {
        if (currentObject.hasOwnProperty(key)) {
          result[key] = currentObject[key];
        }
      }
      return result;
    }, {});
  };

  getFilter = (data) => {
    const filters = JSON.parse(JSON.stringify(FILTERS));
    const facets = data.facets;
    const filter = {};

    for (let key in filters) {
      const currentFacet = facets.find((facet) => facet.name.toLowerCase() === key);
      if (currentFacet) {
        filter[key] = currentFacet.options;
        break;
      }
    }

    console.debug('RefineCVLSearchForm-getFilter - filter: ', filter); //

    return filter;
  };

  /**
   * Get refined data from search api based on the params data
   */
  getListDataFromApi = (params, key) => {
    const { i18n, t, selectedFamily } = this.props;
    const { groups, type, searchTerms } = this.state;
    const familyGroup = groups.find((group) => group.key === selectedFamily).val || '';
    const url = store.getState().content.url;
    const token = store.getState().content.token;

    console.log(`${familyGroup} ${type.value} ${params.text}`);

    params.culture = t('config.CULTURE');
    params.vtype = '2';
    params.text = searchTerms;
    params.facets.familygroup = familyGroup;
    params.facets.family = type.value;
    params.lob = 'b2b';

    if (i18n.language === 'is') {
      params.lob = 'b2c';
    }

    Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        let selectOptions = [];
        const selectedFacet = response.data.facets.find(
          (facet) => facet.name.toLowerCase() === key,
        );

        if (selectedFacet) {
          selectOptions = this.getOptions(selectedFacet.options);
        } else {
          if (response.data.model[0][key]) {
            selectOptions = this.getOptions(response.data.model[0][key]);
          } else {
            selectOptions = this.getOptions(`No ${key} specified`);
          }
        }

        const newState = this.state;
        newState[key] = selectOptions;
        newState.error = false;

        console.debug('RefineCVLSearchForm-getListData - newState.data: ', newState.data); //
        console.debug(
          'RefineCVLSearchForm-getListData - newState.resultData: ',
          newState.resultData,
        ); //

        this.setState(newState);

        this.forceUpdate();
      })
      .catch((error) => {
        this.setState({ error: t('generic_labels.error') });
        console.warn(error);
      });
  };

  /**
   * Repopulates lists after an option has been selected
   * @param {string} - value of key
   */
  getListData = (value) => {
    const { resultData, currentManufacturer, searchTerms } = this.state;
    const filters = JSON.parse(JSON.stringify(resultData));
    const params = {
      text: '',
      facets: {},
    };

    // this maybe a clunky way of filtering but it's clearer to
    // see what needs to be added to params for each filter
    switch (value) {
      case 'manufacturer':
        break;

      case 'series':
        params.facets.manufacturer = currentManufacturer;

        break;

      case 'fuel':
        params.facets.manufacturer = currentManufacturer;
        params.facets.series = filters.series;

        break;

      default:
        if (currentManufacturer) {
          params.facets.manufacturer = currentManufacturer;
        } else {
          params.text = searchTerms;
        }

        break;
    }

    this.getListDataFromApi(params, value);
  };

  // Get new data based on selections
  getNewData = (selectedOption, param) => {
    const { i18n, t } = this.props;
    const { searchTerms, type } = this.state;
    const filters = JSON.parse(JSON.stringify(FILTERS));
    const url = store.getState().content.url;
    const token = store.getState().content.token;
    const newState = JSON.parse(JSON.stringify(this.state));
    const activeFilters = {};
    const value = selectedOption.value;
    const params = {};
    const facets = {};

    params.culture = t('config.CULTURE');
    params.vtype = '2';
    params.text = searchTerms;
    params.lob = 'b2b';

    if (i18n.language === 'is') {
      params.lob = 'b2c';
    }

    facets.family = type.value;
    newState.resultData[param] = value;

    if (param === 'manufacturer') {
      newState.currentManufacturer = value;
    } else if (!newState.resultData.manufacturer) {
      params.text += ` ${searchTerms}`;
    }

    for (let key in newState.resultData) {
      facets[key] = newState.resultData[key];
      activeFilters[key] = newState.resultData[key];

      if (key === param) {
        break;
      }
    }

    params.facets = facets;
    newState.resultData = activeFilters;

    Axios.get(url + '/api/search', {
      params: params,
      headers: { token: token },
    })
      .then((response) => {
        newState.data = response.data;

        if (
          newState.data.facets.filter((facet) => facet.name.toLowerCase() !== 'year').length ===
          0 ||
          newState.data.model.length === 1
        ) {
          for (let key in filters) {
            const value = newState.data.model[0][key];
            newState.resultData[key] = value;
          }

          newState.data.facets = [];
        }

        console.debug('RefineCVLSearchForm-getNewData - newState.data: ', newState.data); //
        console.debug(
          'RefineCVLSearchForm-getNewData - newState.resultData: ',
          newState.resultData,
        ); //

        this.equipment = null;
        this.setState(newState);
      })
      .catch((error) => {
        this.setState({ error: t('generic_labels.error') });
        console.warn(error);
      });

    this.forceUpdate();
  };

  getOptions = (optionsData) => {
    const arr = [];

    if (typeof optionsData === 'object') {
      optionsData.forEach((option) => {
        const options = {
          value: option,
          label: option,
        };

        arr.push(options);
      });
    } else {
      const options = {
        value: optionsData,
        label: optionsData,
      };

      arr.push(options);
    }

    return arr;
  };

  getEquipmentList = (model) => {
    const arr = [];

    model.forEach((element) => {
      let options = {};
      options.value = element.display_name_short;
      options.label = element.display_name_short;
      options.key = element.equipment;
      arr.push(options);
    });

    return arr;
  };

  getSelectInput = (filterData, onOpen) => {
    return Object.keys(filterData).map(function (key) {
      let options = [];

      options = filterData[key]
        ? this.getOptions(filterData[key])
        : this.getOptions(`No ${key} specified`);

      return (
        <SelectInput
          title={key}
          onListOpen={onOpen ? this.getListData : null}
          onClose={this.onClose}
          selectOptions={this.state[key] ? this.state[key] : null}
          key={key}
          value={key}
          options={options}
          handleChange={filterData[key] ? this.getNewData : null}
        />
      );
    }, this);
  };

  render() {
    const { i18n, t, selectedFamily } = this.props;
    const { data, resultData, error } = this.state;
    const equipmentList = this.getEquipmentList(data.model);
    const filter = this.getFilter(data);
    const resultDropdownInputs = resultData ? this.getSelectInput(resultData, true) : '';
    const filterInput = filter ? this.getSelectInput(filter, false) : '';

    if (Object.keys(equipmentList).length === 1) this.equipment = equipmentList[0];

    const errorBlock = <ErrorBlock error={error} />;

    const button = (
      <a
        className="button input"
        onClick={() => {
          this.goToResults();
          ReactGA.event({
            category: i18n.language,
            action: selectedFamily,
            label: 'See Recommendation',
          });
        }}
      >
        {t('generic_labels.recommendation')}
      </a>
    );

    const results = (
      <div className="results">
        {this.equipment &&
          data.facets.filter(
            (facet) =>
              facet.name.toLowerCase() !== 'year' && facet.name.toLowerCase() !== 'familygroup',
          ).length === 0
          ? button
          : ''}
      </div>
    );

    const inputs = (
      <div className="inputs">
        {resultDropdownInputs}
        {filterInput}

        {data.facets.filter(
          (facet) =>
            facet.name.toLowerCase() !== 'year' && facet.name.toLowerCase() !== 'familygroup',
        ).length === 0 ? (
            <SelectInput
              key="equipment"
              title
              handleChange={this.equipmentSelected}
              options={equipmentList}
              onClose={this.onClose}
              value="equipment"
            />
          ) : (
            ''
          )}
      </div>
    );

    return (
      <section className="refine-search-form" ref={(node) => (this.ref = node)}>
        {inputs}
        {results}
        {errorBlock}
      </section>
    );
  }
}

export default translate('translations')(RefineCVLSearchForm);



// WEBPACK FOOTER //
// ./src/components/refineCVLSearchForm.js